import { useWidgetTitleHeight } from "arkh";

export function useWidgetNoteTextTopPadding() {
  return useWidgetTitleHeight();
}
